module.exports = __webpack_public_path__ + "img/visa.8c226cb5.svg";